<template>
  <div class="name">
    <input v-model="name" class="name-input" @change="$emit('changeName', name)" />
  </div>
</template>

<script>
  export default {
    props: {
      childName: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        name: ''
      }
    },
    created() {
      this.name = this.childName
    },

    watch: {
      childName(name) {
        this.name = name
      }
    }
  }
</script>

<style lang="scss" scoped>
  .name {
    width: 300px;
    margin: 0 auto 20px;

    &-input {
      width: 100%;
      height: 30px;

      border: none;
      border-bottom: 2px solid map.get($colors, primary);

      font-size: 24px;
      font-weight: bold;
      text-align: center;
      color: map.get($colors, primary);
    }
  }
</style>
